import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Page.css";
import "../assets/styles/DashboardPage.css";
import { FiPlusCircle, FiLogOut, FiClock, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Card from "../components/common/Card";
import { useNotificacao } from "../context/NotificacaoContext";
import { consultarSaldo, listarLancamentos } from "../services/CreditoService";

export default function Dashboard() {
  const navigate = useNavigate();
  const usuario = JSON.parse(localStorage.getItem("usuario"));
  const empresaId = usuario?.empresaId;
  const itensPorPagina = 5;

  const [saldo, setSaldo] = useState(0);
  const [historico, setHistorico] = useState([]);
  const [animarSaldo, setAnimarSaldo] = useState(false);
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(true);
  const { mostrarNotificacao } = useNotificacao();

  const historicoPaginado = historico.slice(
    (pagina - 1) * itensPorPagina,
    pagina * itensPorPagina
  );

    useEffect(() => {
      async function carregarDados() {
        try {
          const resSaldo = await consultarSaldo(empresaId);
          setSaldo(resSaldo.data.valor || 0);

          if (localStorage.getItem("saldoAtualizado") === "true") {
            if (resSaldo.data.valor > 0){
              setAnimarSaldo(true);
              setTimeout(() => setAnimarSaldo(false), 1200);
              localStorage.removeItem("saldoAtualizado");
            }
          }

          const resLanc = await listarLancamentos(empresaId);
          setHistorico(resLanc.data || []);
        } catch (err) {
          console.error("Erro ao carregar dados: ", err);
          mostrarNotificacao("Não foi possível carregar os dados do dashboard", "error");
        } finally {
          setCarregando(false);
        }
      }

    if (empresaId) carregarDados();
  }, [empresaId, mostrarNotificacao]);

  const handleAddCredit = () => {
    navigate("/incluir-credito");
  };

  const handleLogout = () => {
    localStorage.removeItem("usuario");
    mostrarNotificacao("Sessão encerrada com sucesso!", "info");
    setTimeout(() => navigate("/cadastro"), 2000);
  };

  if (carregando) {
    return (
        <div className="fullscreen-loader">
          <div className="loader-spinner" />
          <span className="loader-text"> Carregando dados...</span>
        </div>
    );
  }

  return (
      <div className="dashboard">
        {/* Linha 1 - Cards principais */}
        <div className="dashboard-page cards-area-2x2">
          <Card 
            className="page-box dashboard-content saldo"
            titulo={`Bem-vindo, ${usuario?.nome || usuario?.email}`} 
            info={`R$ ${saldo.toFixed(2)}`}
            size="large">
              <button className="btn-credit" onClick={handleAddCredit}>
                <FiPlusCircle /> Incluir Crédito
              </button>
              <button className="btn-logout" onClick={handleLogout}>
                <FiLogOut /> Sair
              </button>
          </Card>

          {/* Histórico de créditos/débitos */}
          <Card
            className="page-box dashboard-content"
            titulo="Lançamentos"
            size="large"
            startCollapsed={historicoPaginado.length === 0}>
              {historicoPaginado.length === 0 ? (
                <p>Nenhum lançamento encontrado.</p>
              ) : (
                <>
                  <ul className="historico-lista">
                    {historicoPaginado.map((item) => (
                      <li key={item.id} className="historico-item">
                        <span>
                          {item.tipo} R$ {item.valor.toFixed(2)}
                        </span>
                        <small>{new Date(item.data).toLocaleDateString()}</small>
                      </li>
                    ))}
                  </ul>

                  <div className="paginacao">
                    <button
                      onClick={() => setPagina(p => Math.max(p - 1, 1))}
                      disabled={pagina === 1}
                      className="btn-paginacao"
                    >
                      <FiChevronLeft size={20} />
                    </button>
                    <span className="pagina-atual">{pagina}</span>
                    <button
                      onClick={() => setPagina(p => p + 1)}
                      disabled={pagina * itensPorPagina >= historicoPaginado.length}
                      className="btn-paginacao"
                    >
                      <FiChevronRight size={20} />
                    </button>
                  </div>
                </>
              )}
          </Card>
        </div>

        {/* Linha 2 - Gráficos */}
        <div className="linha-graficos">
          {/* <GraficosDashboard className="grafico page-box"/> */}
        </div>

        {/* Linha 3 - Atalhos e novidades */}
        <div className="atalhos">
          {/* <button>Histórico de Conversas</button>
          <button>Configurar Mensagens Automáticas</button>
          <button>Adicionar Canal</button> */}
        </div>

        <div className="novidades">
          {/* <h4>Novidades</h4>
          <p>Agora você pode integrar com Telegram! Clique aqui para saber mais.</p> */}
        </div>

        {/* <ToastContainer /> */}
      </div>

  );
}
